export enum ButtonTemplateType {
  Phone = 'phone',
  Expansion = 'expansion',
}
